import { ReactNode } from 'react';
import { CardHeader, Row, Col, Button, ButtonProps } from 'reactstrap';

const DEFAULT_ICONS: Record<string, string> = { Back: 'fa-arrow-left', Save: 'fa-save' };

export const buttonIcon = (button: { icon?: string; label?: string }): string =>
  button?.icon ?? DEFAULT_ICONS[String(button?.label || '')] ?? '';

type CardHeaderTopFormButtonsProps = { pageTitle: string; buttons?: ButtonProps[]; extra?: ReactNode };

const CardHeaderTopFormButtons = ({ pageTitle, buttons, extra }: CardHeaderTopFormButtonsProps) => {
  return (
    <CardHeader className="bg-white border-0">
      <Row className="align-items-center">
        <Col xs="8">
          <h3 className="mb-0">{pageTitle}</h3>
        </Col>
        <Col className="text-right" xs="4">
          {buttons?.map((b: any, i: number) => (
            <Button
              key={`buttons-headers-${i}`}
              color={b.color || 'primary'}
              className="float-right mr-2"
              disabled={b.disabled}
              onClick={(e) => b.onClick(e)}
            >
              {buttonIcon(b) ? <i className={`fas ${buttonIcon(b)} mr-2`} /> : null}
              {b.label}
            </Button>
          ))}
          {extra}
        </Col>
      </Row>
    </CardHeader>
  );
};

export default CardHeaderTopFormButtons;
